import React, { useContext } from "react";
import { WebsiteContext } from "../context/AppContext";


const CityCard = ({img,text}) => {
   const { isMobileView } = useContext(WebsiteContext);
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: isMobileView ? 10 : 20,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src={img}
          alt="coimbatore"
          height={ 80}
          width={ 80}
          style={{ borderRadius: 50 }}
        />
        <span
          style={{
            fontFamily: "Nexa-Bold",
            fontSize: 18,
            color: "#000000",
          }}
        >
          {text}
        </span>
      </div>
    </>
  );
};

export default CityCard;
